import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "import",
  "use": "import-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"import\"><path d=\"M512 32v448c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-99c0-17.673 14.327-32 32-32s32 14.327 32 32v67h384V64H64v67c0 17.673-14.327 32-32 32S0 148.673 0 131V32C0 14.327 14.327 0 32 0h448c17.673 0 32 14.327 32 32zM0 256c0 17.673 14.327 32 32 32h166.746l-9.86 9.86c-12.497 12.497-12.497 32.758-.001 45.255 6.25 6.249 14.438 9.374 22.628 9.373 8.188 0 16.38-3.125 22.627-9.373l64.488-64.488a31.997 31.997 0 0 0 0-45.254l-64.488-64.488c-12.496-12.497-32.757-12.497-45.255 0-12.496 12.497-12.496 32.758.001 45.255l9.86 9.86H32c-17.673 0-32 14.327-32 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/import.svg
// module id = WUx2
// module chunks = 1